import { AlertTriangle, LogOut } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";

export function LeaveInterviewDialog({ open, onStay, onLeave }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onStay(); }}>
      <DialogContent className="sm:max-w-md" data-testid="leave-interview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-500" /> Leave Oral Board?</DialogTitle>
          <DialogDescription>Your current interview will be lost if you leave this page. It won't be scored or saved, and the board still counts as used.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col sm:flex-row gap-2 mt-2">
          <Button onClick={onStay} className="h-11 flex-1" data-testid="leave-interview-stay">Stay in interview</Button>
          <Button onClick={onLeave} variant="outline" className="h-11 flex-1 border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800" data-testid="leave-interview-leave"><LogOut className="w-4 h-4 mr-2" /> Leave interview</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
